(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immortals-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.faq-accordion__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immortals-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'immortalsWelcomePopupSeen';

  document.querySelectorAll('[id^="imm-wp-"]').forEach(function (popup) {
    var isDesignMode = popup.dataset.designMode === 'true';
    var alreadySeen = false;
    try {
      alreadySeen = window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (_) { /* localStorage unavailable */ }

    if (alreadySeen && !isDesignMode) return;

    var closeBtn = popup.querySelector('.imm-wp__close');
    var ctaBtn = popup.querySelector('[data-imm-wp-cta]');
    var htmlEl = document.documentElement;
    var scrollbarPadding = 0;

    function lockScroll() {
      scrollbarPadding = window.innerWidth - htmlEl.clientWidth;
      htmlEl.classList.add('imm-wp-scroll-lock');
      if (scrollbarPadding > 0) {
        document.body.style.paddingRight = scrollbarPadding + 'px';
      }
    }

    function unlockScroll() {
      htmlEl.classList.remove('imm-wp-scroll-lock');
      document.body.style.paddingRight = '';
    }

    function open() {
      popup.classList.add('is-open');
      lockScroll();
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      popup.classList.remove('is-open');
      unlockScroll();
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (_) { /* localStorage unavailable */ }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', close);
    }

    // Close when tapping the dimmed backdrop (outside .imm-wp__modal) —
    // only the close button and CTA closed it before, which isn't the
    // gesture people reach for first, especially on mobile.
    popup.addEventListener('click', function (e) {
      if (e.target === popup) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    window.setTimeout(open, 400);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
